<app-page-header-nav
    [title]="'Payment Details'"
    [navItems]="navigationItems"
></app-page-header-nav>
